import { STUDENT_ROLE } from '../constants'

const getProfileByRole = (userData, role) => {
  try {
    return role === STUDENT_ROLE ? userData.user_student_profile : userData.user_tutor_profile
  } catch (e) {
    console.log(e)
    return null
  }
}

export default getProfileByRole
